<script setup lang="ts">
import type { DropdownItem } from '#ui/types'

const [inviteModalOpened, toggleInviteModal] = useToggle()
const { logoutAndClearLocalStorage } = useAuth()
const { user } = useCurrentUser()
const { enabled: skillsEnabled } = useFlag('SLEUTH_SKILLS')

const dropdownItems = computed(
  () =>
    [
      [
        {
          label: 'User settings',
          icon: 'regular:user',
          to: { name: 'settings-user' },
        },
      ],
      [
        {
          label: 'General settings',
          icon: 'regular:gear',
          to: { name: 'settings-organization' },
        },
        {
          label: 'Invite members',
          icon: 'regular:user-group',
          click: () => toggleInviteModal(),
        },
        ...(skillsEnabled.value
          ? [
              {
                label: 'Roles',
                icon: 'regular:masks-theater',
                to: { name: 'roles' },
              },
            ]
          : []),
      ],
      [
        {
          label: 'Sign out',
          icon: 'regular:arrow-right-from-bracket',
          click: logoutAndClearLocalStorage,
        },
      ],
    ] as DropdownItem[][],
)
</script>

<template>
  <UDropdown :items="dropdownItems" :ui="{ width: 'w-56' }" :popper="{ placement: 'top-start' }">
    <NavigationItem icon="light:user" :label="user?.display ?? 'Account'">
      <template v-if="user?.gravatar" #leading>
        <img :src="user.gravatar" :alt="user.display" class="size-4 shrink-0 rounded-full object-cover" />
      </template>
    </NavigationItem>
  </UDropdown>

  <SettingsOrgInviteModal v-model="inviteModalOpened" />
</template>
